import React, { useState } from "react";
import "../style/ContactPage.css";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess("");

    try {
      await addDoc(collection(db, "contactMessages"), {
        ...formData,
        createdAt: serverTimestamp(),
      });

      setSuccess("Your message has been sent successfully!");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Header */}
      <div className="contact-hero">
        <h1>Contact Us</h1>
        <p>We’re here to help. Reach out to us anytime.</p>
      </div>

      {/* Info Cards */}
      <div className="contact-info-grid">
        <div className="info-card">
          <h3>Email</h3>
          <p>
            <a
  href="https://mail.google.com/mail/?view=cm&fs=1&to=support@couponlagao.com"
  target="_blank"
  rel="noopener noreferrer"
>
  sales@couponlagao.in
</a>

          </p>
        </div>

        <div className="info-card">
          <h3>Phone</h3>
          <p>
            <a href="tel:+918791153542">+91 87911 53542</a>
          </p>
        </div>

        <div className="info-card">
          <h3>Address</h3>
          <p>
            CouponLagao Pvt. Ltd. <br />
            Gurugram, India
          </p>
        </div>
      </div>

      {/* Contact Form */}
      <div className="contact-form-wrapper">
        <h2>Send us a Message</h2>

        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          />

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </button>

          {success && <p className="success-msg">{success}</p>}
        </form>
      </div>
    </div>
  );
}
